/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  Dashboard,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Dashboard
 */
export const dashboard = (

 signal?: AbortSignal
) => {


      return axiosClient<Dashboard>(
      {url: `/dashboard`, method: 'GET', signal
    },
      );
    }




export const getDashboardQueryKey = () => {
    return [
    'dashboard'
    ] as const;
    }


export const getDashboardQueryOptions = <TData = Awaited<ReturnType<typeof dashboard>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDashboardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboard>>> = ({ signal }) => dashboard(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
}

export type DashboardQueryResult = NonNullable<Awaited<ReturnType<typeof dashboard>>>
export type DashboardQueryError = ErrorType<StandardError>


/**
 * @summary Dashboard
 */

export function useDashboard<TData = Awaited<ReturnType<typeof dashboard>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDashboardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






